// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"CircleLoading_loadingWrapper__m44rp","spin":"CircleLoading_spin__Ts4Bp"};